import { SET_HOME_PAGE_DASHBOARDS_CONFIG } from '../actions/actionTypes';

export default function homePageDashboardsConfig(state = {}, action) {
  if (action.type === SET_HOME_PAGE_DASHBOARDS_CONFIG) {
    return action.payload;
  } else {
    return state;
  }
}
